import { useTranslation } from 'react-i18next';
import { LANGUAGES, setLanguage } from '../i18n';
import type { Language } from '../i18n';
import { IconGlobe } from './Icons';

export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'de').slice(0, 2) as Language;

  return (
    <label className="row" style={{ gap: 6 }}>
      <span className="visually-hidden">{t('app.language')}</span>
      <IconGlobe width={18} height={18} aria-hidden="true" className="muted" />
      <select
        className="select"
        style={{ width: 'auto', padding: '7px 10px' }}
        value={LANGUAGES.includes(current) ? current : 'de'}
        onChange={(e) => setLanguage(e.target.value as Language)}
        aria-label={t('app.language')}
      >
        <option value="de">{t('app.languageGerman')}</option>
        <option value="en">{t('app.languageEnglish')}</option>
      </select>
    </label>
  );
}
